/*=========================================================================================
  File Name: misaNotification.js
  Description: Toàn bộ logic tích hợp MISA Notification V2 (Incident + In-App)
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  ==========================================================================================*/

/**
 * Khởi tạo MISA Notification với token và inApp
 * @param {Object} options
 * @param {Function} options.getToken - Hàm lấy JWT token, nhận forceRefresh (boolean)
 * @param {Function} options.onAuthError - Hàm xử lý khi lấy token thất bại
 * @param {Function} [options.inApp] - Callback khởi tạo inApp (nếu có)
 */
async function setup(options) {
	var token = await options.getToken();
	// Bổ sung thêm điều kiện trước khi thực hiện init
	if (!token) return;

	window.MISA_Notification.init({
		token: token,
		onTokenInvalid: function(continueFn) {
			options
				.getToken(true)
				.then(function(newToken) {
					continueFn(newToken);
				})
				.catch(function() {
					options.onAuthError();
				});
		},
		language: 'vi'
	});

	if (options.inApp) {
		options.inApp();
	}
}

/**
 * Khởi tạo MISA Notification — tự động đợi loader script nếu chưa sẵn sàng
 * @param {Object} options - Xem setup()
 */
export function initMisaNotification(options) {
	var cfg = window.__env && window.__env.misaNotificationV2;
	//Nếu không bật cờ sử dụng notifi v2
	if (!cfg || !cfg.isUsingNotifyV2) return;

	if (window.MISA_Notification) {
		setup(options);
	} else {
		document.addEventListener(
			'MISANotificationLibReady',
			function() {
				setup(options);
			},
			{ once: true }
		);
	}
}

/**
 * Hủy kết nối MISA Notification In-App khi logout
 * KHÔNG dùng optional chaining (?.) để tương thích với mọi trình duyệt
 */
export function destroyMisaNotification() {
	if (window.MISA_Notification && window.MISA_Notification.inApp) {
		window.MISA_Notification.inApp.disconnect();
	}
}
